import { UpgradePromotionBoxCopy } from '@chegg-wt/core/types/copy'
import { ListItemProps } from '@chegg/wt-checkout'

export const upgradePromotionCopy: UpgradePromotionBoxCopy = {
  buttonText: 'Try it now',
  mainHeading: 'Check your paper before your teacher does!',
  subHeading:
    'Avoid plagiarism — quickly check for missing citations and check for writing mistakes.',
}

// WT-Checkout FeatureList
export const bmFeatureList: ListItemProps[] = [
  {
    text:
      'Improving sentence structure, punctuation, writing style, and grammar with our suggestions',
  },
  {
    text: 'Check for missing citations and unintentional plagiarism',
  },
  {
    text: 'Add accurate citations and a bibliography directly to your paper',
  },
  {
    text: 'Create accurate citations for multiple styles and source types',
  },
]
